var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#27AE60",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6305 33.2621V39.1536C25.6305 40.7813 24.3108 42.0994 22.6847 42.0994H19.3754C17.7494 42.0994 16.4297 40.7813 16.4297 39.1536V33.2621C16.4297 31.6344 17.7494 30.3164 19.3754 30.3164H22.6847C24.3108 30.3164 25.6305 31.6344 25.6305 33.2621Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5719 20.6371V39.1532C36.5719 39.9342 36.2605 40.6833 35.7084 41.2354C35.1563 41.7892 34.4072 42.0989 33.6262 42.0989H30.3168C29.5358 42.0989 28.7867 41.7892 28.2346 41.2354C27.6808 40.6833 27.3711 39.9342 27.3711 39.1532V20.6371C27.3711 19.8561 27.6808 19.107 28.2346 18.5549C28.7867 18.0011 29.5358 17.6914 30.3168 17.6914H33.6262C34.4072 17.6914 35.1563 18.0011 35.7084 18.5549C36.2605 19.107 36.5719 19.8561 36.5719 20.6371Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5704 27.3715V39.1545C47.5704 39.9355 47.2607 40.6846 46.7069 41.2367C46.1548 41.7905 45.4057 42.1002 44.6247 42.1002H41.3154C40.5343 42.1002 39.7853 41.7905 39.2332 41.2367C38.681 40.6846 38.3696 39.9355 38.3696 39.1545V27.3715C38.3696 26.5905 38.681 25.8414 39.2332 25.2893C39.7853 24.7355 40.5343 24.4258 41.3154 24.4258H44.6247C45.4057 24.4258 46.1548 24.7355 46.7069 25.2893C47.2607 25.8414 47.5704 26.5905 47.5704 27.3715Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8328 43.7812C49.5297 43.7812 50.0953 44.3468 50.0953 45.0437C50.0953 45.7406 49.5297 46.3062 48.8328 46.3062H15.1672C14.4704 46.3062 13.9048 45.7406 13.9048 45.0437C13.9048 44.3468 14.4704 43.7812 15.1672 43.7812H48.8328Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.e5f3e3e5f6f25d7ce55afc3b6c2e9ecc.svg";
export { ForwardRef as ReactComponent };